import React, { useEffect } from "react";
import {
  Switch,
  BrowserRouter,
  Route,
  useHistory,
  Redirect,
} from "react-router";

const ManagerSummaryComponent = () => {
  const history = useHistory();

  useEffect(() => {
    (async () => {
      await localStorage.setItem("skygeni-user-page", "Sales Productivity");
      await localStorage.setItem("skygeni-user-salesProductivityPage", "Manager Summary");
      await localStorage.removeItem("skygeni-user-enhancedPage");
      await localStorage.removeItem("skygeni-user-productPage");
    await localStorage.removeItem("skygeni-user-SettingsPage");
    await localStorage.removeItem("skygeni-user-pipelineProgressionPage");
    await localStorage.removeItem("skygeni-user-pipelineVelocityandConversionPage")
    await localStorage.removeItem("skygeni-user--pipelineBuildandSuficencyPage")
    await localStorage.removeItem("skygeni-user-marketIntelandGrowthLeversPage");
    await localStorage.removeItem("skygeni-user-personalizedScorecardsPage");
    await localStorage.removeItem("skygeni-user-growthScienceInsightsPage");
      history.push("/");
      window.location.reload();
    })();
  }, []);

  return <div style={{ margin: "1rem auto" }}>Loading...</div>;
};

export default ManagerSummaryComponent;
